import {ITableColumn} from '../../types';
import {ReactNode} from 'react';
import {RatePlan} from "../rate-plans/types.ts";
import {Product} from "../products/types.ts";


export enum PriceStatus {
    Active = 'Active',
    Inactive = 'Inactive',
}

export enum RecurringOption {
    Yes = 'Yes',
    No = 'No',
}

export enum BillingPeriod {
    Monthly = 'Monthly',
    Annually = 'Annually',
    Daily = 'Daily',
    Weekly = 'Weekly',
    Custom = 'Custom',
}

export enum PricingModel {
    FlatRate = 'FlatRate',
    PackageBased = 'PackageBased',
    VolumeBased = 'VolumeBased',
    UsageBased = 'UsageBased',
}


export type Price = {
    id: string,
    productId: string,
    product?: Product,
    priceStatus: PriceStatus,
    pricingModel: PricingModel,
    recurringOption: RecurringOption,
    amount: number,
    ratePlanId: string,
    ratePlan?: RatePlan,
    description: string,
    billingPeriod: BillingPeriod,
    stripePriceId?: string,
    createdByUsername?: string,
    createdBy?: { givenName: string, familyName: string },
    created?: string,
    updated?: string,
}


export interface IPriceTableColumn extends ITableColumn {
    render?: (item: Price) => ReactNode;
}

export type ListPrices = {
    listPrices: { items: Price[], nextToken: string }
}

export type GetPrice = {
    getPrice: Price
}

export type CreatePrice = {
    createPrice: Price
}

export type UpdatePrice = {
    updatePrice: Price
}

export type DeletePrice = {
    deletePrice: string
}
